import type React from 'react'
import * as R from 'ramda'

type MergeableRef<T> =
  React.MutableRefObject<T | null> | React.RefCallback<T> | null | undefined

export const mergeRefs =
  <T>(refs: Array<MergeableRef<T>>): React.RefCallback<T> =>
  value => {
    refs.forEach(ref => {
      const isRefTypeOfFunction = R.equals(typeof ref, 'function')
      const isRefAvailable = R.not(R.isNil(ref))

      if (isRefTypeOfFunction) {
        ;(ref as React.RefCallback<T>)(value)
      } else if (isRefAvailable) {
        ;(ref as React.MutableRefObject<T | null>).current = value
      }
    })
  }
